import { useEffect, useState } from "react";

import BackToTop from "../elements/BackToTop";
import Footer1 from "./footer/Footer1";
import Footer2 from "./footer/Footer2";
import Header1 from "./header/Header1";
import Header2 from "./header/Header2";
import MobileMenu from "./MobileMenu";
import ModalForgotPassword from "./ModalForgotPassword";
import ModalLogin from "./ModalLogin";
import ModalRegister from "./ModalRegister";

export default function Layout({
	headerStyle,
	breadcrumbTitle,
	children,
	backAlt,
}) {
	const [scroll, setScroll] = useState(0);
	// Mobile Menu
	const [isMobileMenu, setMobileMenu] = useState(false);
	const handleMobileMenu = () => setMobileMenu(!isMobileMenu);
	const footerStyle = 1;
	// Cart
	const [isCart, setCart] = useState(false);
	const handleCart = () => setCart(!isCart);

	const [isLogin, setLogin] = useState(false);
	const handleLogin = () => {
		setLogin(!isLogin);
		!isLogin
			? document.body.classList.add("modal-open")
			: document.body.classList.remove("modal-open");
	};
	// Register
	const [isRegister, setRegister] = useState(false);
	const handleRegister = () => {
		setRegister(!isRegister);
		!isRegister
			? document.body.classList.add("modal-open")
			: document.body.classList.remove("modal-open");
	};
	const [isForgotPass, setForgotPass] = useState(false);
	const handleForgotPass = () => {
		setForgotPass(!isForgotPass);
		!isForgotPass
			? document.body.classList.add("modal-open")
			: document.body.classList.remove("modal-open");
	};

	useEffect(() => {
		const WOW = require("wowjs");
		window.wow = new WOW.WOW({
			live: false,
		});
		window.wow.init();

		const onScroll = () => {
			setScroll(window.scrollY > 100);
		};

		window.addEventListener("scroll", onScroll);
		return () => window.removeEventListener("scroll", onScroll);
	}, []);
	return (
		<>
			<div id="top" />
			{/* <AddClassBody /> */}

			<Header1
				scroll={scroll}
				isMobileMenu={isMobileMenu}
				handleMobileMenu={handleMobileMenu}
			/>
			<MobileMenu
				isMobileMenu={isMobileMenu}
				handleMobileMenu={handleMobileMenu}
			/>
			{children}

			<Footer1 />
			<BackToTop target="#top" backAlt={backAlt} />
			<ModalLogin
				isLogin={isLogin}
				handleLogin={handleLogin}
				isRegister={isRegister}
				handleRegister={handleRegister}
				isForgotPass={isForgotPass}
				handleForgotPass={handleForgotPass}
			/>
			<ModalRegister
				isRegister={isRegister}
				handleRegister={handleRegister}
				isLogin={isLogin}
				handleLogin={handleLogin}
			/>
			<ModalForgotPassword
				isForgotPass={isForgotPass}
				handleForgotPass={handleForgotPass}
				isLogin={isLogin}
				handleLogin={handleLogin}
			/>
		</>
	);
}
